module.exports = __webpack_public_path__ + "images/emoji/volcano.f5ee6c0c0074f4a1d2dc.png";